module.exports = "<div #chart class=\"chart\"></div>"